import { Component, OnInit, Inject } from '@angular/core';
import { ErrorsService } from '../../utils/services/errors.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-error-pop-up',
  templateUrl: './error-pop-up.component.html',
  styleUrls: ['./error-pop-up.component.css']
})
export class ErrorPopUpComponent implements OnInit {

  constructor(
    private errorsService: ErrorsService,
    public dialogRef: MatDialogRef<ErrorPopUpComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
  }

  ngOnInit() {
  }

  /**Function to navigate default page when error found*/
  errorAction(data) {
    if (data.code === 401 || data.code === 403 ) {
      sessionStorage.clear();
      this.router.navigate(['/']);
    } else {
    }
  }
}






// WEBPACK FOOTER //
// ./src/app/common/error-pop-up/error-pop-up.component.ts